// extracted by mini-css-extract-plugin
export var bodyRow = "_g8-d";
export var cardColumns = "_g8-e";
export var ellipsesOverflow = "_g8-2";
export var flatBottomCorners = "_g8-3";
export var flatTopCorners = "_g8-4";
export var headerActionsDropdown = "_g8-f";
export var headerBottomRow = "_g8-c";
export var headerTopRow = "_g8-b";
export var orderDetailsWrapper = "_g8-0";
export var orderInfoContainer = "_g8-1";
export var productDetails = "_g8-9";
export var productImage = "_g8-5";
export var responsiveTable = "_g8-8";
export var shipmentContainer = "_g8-a";
export var tableBottomLeft = "_g8-6";
export var tableBottomRight = "_g8-7";
export var trackingLink = "_g8-g";